import { render, staticRenderFns } from "./CreateDigitalForm.vue?vue&type=template&id=2eac4950&scoped=true&"
import script from "./CreateDigitalForm.vue?vue&type=script&lang=js&"
export * from "./CreateDigitalForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateDigitalForm.vue?vue&type=style&index=0&id=2eac4950&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eac4950",
  null
  
)

export default component.exports